import { useCallback } from 'react';
import { dateToApiFormat } from '../../helpers/dateHelper';
import { ReadRoster, useGetRostersOverviewQuery } from '../gql/graphql.generated';
import { useDaysInMonth } from '../settings/useDates';

export const useGetRostersForMonth = (locationId: number, date: Date) => {
  const dates = useDaysInMonth(date);
  const [{ data }, refetchMutation] = useGetRostersOverviewQuery({
    variables: {
      locationId,
      startDate: dateToApiFormat(dates[0]),
      endDate: dateToApiFormat(dates[dates.length - 1])
    },
    requestPolicy: 'cache-and-network'
  });

  const rosters = (data?.rostersInDateRange || []) as ReadRoster[];

  const refetch = useCallback(async () => {
    await refetchMutation({ requestPolicy: 'network-only' });
  }, [refetchMutation]);

  return { rosters, refetch };
};
